import { Map, Set } from 'immutable';

import * as types from './types';
import { types as teamsTypes } from './../../ducks/teams';

const initialState = Map({
  loading: true,
  hasTeamsAvailableInitially: false,
  selectedTeams: Set(),
  pagination: Map({
    currentPage: 1,
  }),
});

const teamsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.UPDATE_OFFSET:
      return state.setIn(['pagination', 'currentPage'], payload);
    case types.TOGGLE_TEAM_SELECTION: {
      const selection = state.get('selectedTeams');
      const newSelection = selection.has(payload) ?
        selection.delete(payload) :
        selection.add(payload);
      return state.set('selectedTeams', newSelection);
    }
    case types.SET_TEAMS_SELECTION: {
      if (payload.checked) {
        return state.set(
          'selectedTeams',
          state.get('selectedTeams').concat(payload.teams.keySeq()),
        );
      }
      const newSelection = state.get('selectedTeams').withMutations((selection) => (
        payload.teams.keySeq().forEach((teamId) => {
          selection.delete(teamId);
        })
      ));
      return state.set('selectedTeams', newSelection);
    }
    case teamsTypes.TEAM_REMOVE.SUCCESS: {
      return state.withMutations((mutable) => {
        const selection = mutable.get('selectedTeams');
        if (selection.has(payload)) {
          mutable.set('selectedTeams', selection.delete(payload));
        }
      });
    }
    case types.INITIAL_TEAM_TABLE.SUCCESS:
      return state.withMutations((mutable) => {
        mutable
          .set('loading', false)
          .set('hasTeamsAvailableInitially', payload.count !== 0);
      });
    default:
      return state;
  }
};

export default teamsReducer;
